import { z } from "zod";
import { Currency, HireUnitType } from "@/gql/graphql";

export const createSupplierValidation = z.object({
  name: z.string().min(3, "Business name must be at least 3 characters"),
  currency: z.nativeEnum(Currency),
  hire_unit_type: z.nativeEnum(HireUnitType, {
    error: "Please select a unit type",
  }),
});
